<template>
<div v-if="dataLoaded">
    <table-page
        :client="client"
        @updated="getData"
        :warnings="warnings"
        :changelogs="changelogs"
    >
        <fast-table
            :recordLabel="recordLabel"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentRowId"
            @click="currentRowId = $event.id"
        >
            <template v-slot:table-actions>
                <button class="btn btn-primary btn-collapse" id="addButton" @click="addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Deferred Compensation Plan</span>
                </button>
            </template>
        </fast-table>

        <add-form-modal
            v-if="addModalOpen"
            :client="client"
            :plans="plans"
            @updated="getData"
            @close="addModalOpen = false"
        />
    </table-page>

    <sidebar
        v-if="currentRowId"
        :client="client"
        :plan-id="currentRowId"
        @updated="getData"
        @close="currentRowId = null"
    >
    </sidebar>
</div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import Sidebar from './components/DeferredCompPlans/Sidebar'
import AddFormModal from './components/DeferredCompPlans/AddFormModal'

export default {
    components: {FastTable, Sidebar, AddFormModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        alphabeticalCompanies() {
            return Array.from(this.client.companies).sort((a, b) => a.name.localeCompare(b.name))
        },
        currentRow() {
            return this.plans.find(x => (x.id == this.currentRowId))
        },
        sections() {
            return [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: true, id: 'inactive', hasDateFilter: false},
            ]
        },
        tableData() {
            const tableData = []

            const sections = [
                this.plans.filter(obj => obj.is_active && !obj.is_past),
                this.plans.filter(obj => !obj.is_active || obj.is_past),
            ]

            sections.forEach((section, idx) => {
                const sectionData = []

                section.forEach(obj => {
                    const company = this.client.companies.find(c => c.id == obj.company_id)
                    sectionData.push({
                        id: obj.id,
                        object: obj,
                        cells: [
                            obj.provider_name,
                            company.name,
                            obj.plan_type_pretty,
                            this.$filters.date(obj.starts_on) + ' – ' + (obj.ends_on ? this.$filters.date(obj.ends_on) : 'Indefinite'),
                            obj.money_manager_pretty,
                        ],
                    })
                })

                tableData.push(sectionData)
            })

            return tableData
        },
    },
    data() {
        return {
            plans: [],
            dataLoaded: false,
            currentRowId: null,
            recordLabel: "Plan",
            headers: [
                {label: 'Provider', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Company', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Plan Type', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Plan Period', classes: '', isSearchable: false, isFilterable: false},
                {label: 'Money Manager', classes: '', isSearchable: false, isFilterable: true},
            ],
            addModalOpen: false,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Deferred Compensation Plans')
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/deferred-comp-plans`).then(resp => {
                this.dataLoaded = true
                this.plans = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
    },
}
</script>
